import Wrapper from "../../../layout/Wrapper";
import UserComponent from "../../../screens/settings/users";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "User Management",
	description: "",
};

export default function User() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<UserComponent />
		</Wrapper>
	);
}